import { BasicLayout } from '@components/layouts/basic-layout'
import { BaseBlock } from '@components/base-block'
import { TextButton } from '@components/base-button'
import { BaseCell } from '@components/base-cell'
import { BaseGrid } from '@components/base-grid'
import { HeadingS, HeadingXS } from '@components/base-typography'
import { Routes } from '@lib/routes'
import { useLogout } from '@modules/auth/hooks/use-logout'
import { colors } from '@styles/colors'
import { borderRadius, transition } from '@styles/utils'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { padding } from 'polished'
import { useStyletron } from 'styletron-react'
import { Icon } from '@components/icon'

interface SettingsLayoutProps {
  children?: React.ReactNode
  helmetTitle?: string
}

export const SettingsLayout = ({
  children,
  helmetTitle,
}: SettingsLayoutProps) => {
  const [css] = useStyletron()
  const router = useRouter()

  const { logout } = useLogout()

  return (
    <BasicLayout helmetTitle={helmetTitle}>
      <BaseGrid>
        <BaseCell
          spaceTop={48}
          span={[0, 2, 3]}
          style={{ position: 'relative' }}
        >
          <BaseBlock
            className={css({
              display: 'flex',
              flexDirection: 'column',
              position: 'absolute',
              width: 'calc(100% - 48px)',
            })}
          >
            <BaseBlock
              flexbox
              alignCenter
              columnGap="4px"
              marginBottom="16px"
              cursor="pointer"
              onClick={() => {
                router.push(Routes.PATIENT_HOME)
              }}
              paddingTop="8px"
              paddingBottom="8px"
              rounded={8}
              className={css({
                ...transition(),
                ':hover': {
                  backgroundColor: colors.gray50,
                },
              })}
            >
              <Icon type="ChevronLeft" size={20} />
              <HeadingS>설정</HeadingS>
            </BaseBlock>
            {[
              {
                id: 1,
                href: Routes.SETTINGS_ACCOUNT,
                label: '계정 관리',
              },
              {
                id: 2,
                href: Routes.SETTINGS_NOTIFICATIONS,
                label: '알림 설정',
              },
              {
                id: 3,
                href: Routes.SETTINGS_INQUIRIES,
                label: '문의 내역',
              },
            ].map(({ id, href, label }) => (
              <Link href={href} passHref key={id}>
                <a
                  className={css({
                    ...padding('12px'),
                    ...borderRadius(8),
                    backgroundColor: router.pathname.includes(href)
                      ? colors.blue50
                      : colors.white,
                    ...transition(),
                    ':hover': {
                      backgroundColor: colors.gray50,
                    },
                  })}
                >
                  <HeadingXS
                    weight={400}
                    color={
                      router.pathname.includes(href)
                        ? colors.blue400
                        : colors.gray700
                    }
                  >
                    {label}
                  </HeadingXS>
                </a>
              </Link>
            ))}
          </BaseBlock>
        </BaseCell>
      </BaseGrid>
      <BaseGrid>
        <BaseCell span={[0, 2, 2]}></BaseCell>
        <BaseCell skip={[0, 0, 1]} span={[4, 6, 9]}>
          <HeadingS marginBottom="32px">{helmetTitle}</HeadingS>
          {children}
        </BaseCell>
      </BaseGrid>
    </BasicLayout>
  )
}
